export default __webpack_public_path__ + "static/2_4-a9768ae008a20a4be1ec6b4fef895bc6.jpeg";